import { FILE_ANALYSIS_PROMPT } from '../constants/ai/prompts';

export async function analyzeFile(content: string) {
  try {
    const response = await fetch('/api/ai-generate', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        messages: [
          {
            role: 'system',
            content: FILE_ANALYSIS_PROMPT,
          },
          {
            role: 'user',
            content: `Please analyze this file content:\n\n${content}`,
          },
        ],
        temperature: 0.7,
        max_tokens: 1500,
      }),
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Server responded with ${response.status}: ${errorText}`);
    }

    const result = await response.json();
    return result.choices[0]?.message?.content;
  } catch (error) {
    console.error('Error analyzing file:', error);
    throw error;
  }
}
